class StorageKeys {
  public static readonly UserTokensKey = "gcpUserTokens";
  public static readonly CodeVerifierKey = "codeVerifier";
}

export default StorageKeys;
